import { render, staticRenderFns } from "./VerificarLicencaBtn.vue?vue&type=template&id=fe696ac4&scoped=true&"
import script from "./VerificarLicencaBtn.vue?vue&type=script&lang=js&"
export * from "./VerificarLicencaBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe696ac4",
  null
  
)

export default component.exports